import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { selectCurrentRegionId, selectParentRegion } from '../../../selectors/regions';

export function usePuids() {
  const currentRegion = useSelector(selectCurrentRegionId);
  const parentRegion = useSelector(selectParentRegion);

  return useMemo(
    () => ({
      puid5: `obl_id_${parentRegion || currentRegion}`,
    }),
    [currentRegion, parentRegion],
  );
}
